import { Component, inject, input } from '@angular/core';

import { StorefrontPage } from '../../model/storefront-page';
import { SeoService } from '../../service/seo.service';
import { WebsiteService } from '../../service/website.service';
import { SocialComponent } from '../layout/social.component';

@Component({
  selector: 'contacts-page',
  imports: [SocialComponent],
  host: {
    style: 'display: contents'
  },
  template: `
    <!-- Title Page -->
    <section class="bg-title-page p-t-15 p-b-16 flex-col-c-m">
      <h1 class="l-text2 t-center">
        Контакти
      </h1>
    </section>

    <!-- content page -->
    <section class="bgwhite p-t-66 p-b-60">
      <div class="container">
        <div class="row">
          <div class="col-md-6 p-b-30">
            <h4 class="m-text26 p-b-36 p-t-15">
              Інтернет-магазин {{website().host}}
            </h4>
            @if (website().phone) {
              <p class="s-text3 w-size27">
                Телефон: <a class="s-text7" [href]="'tel:' + website().phone">{{website().phone}}</a>
              </p>
            }
            @if (website().email) {
              <p class="s-text3 w-size27">
                Email: <a class="s-text7" [href]="'mailto:' + website().email">{{website().email}}</a>
              </p>
            }
            <div class="flex-m">
              <p class="s-text3 w-size27 p-r-20">
                Соціальні мережі:
              </p>
              <social />
            </div>
          </div>
        </div>
        @for (contact of website().contacts ?? []; track $index) {
          <div class="row">
            <div class="col">
              <h4 class="m-text26 p-b-36 p-t-15">{{contact.title}}:</h4>
              <div class="row">
                <div class="col-md-6 p-b-30">
                  <p class="s-text3 w-size27" [innerHTML]="contact.text"></p>
                </div>
                @if (contact.mapSuffix) {
                  <div class="col-md-6 p-b-30">
                    <iframe class="lazyload" height="300"
                      frameborder="0" style="border:0" allowfullscreen [attr.data-src]="'https://www.google.com/maps/embed' + contact.mapSuffix"></iframe>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </section>
    `
})
export class ContactsPageComponent {

  readonly data = input.required<StorefrontPage>();
  readonly website = inject(WebsiteService).current;

  constructor() {
    inject(SeoService).page(this.data, true);
  }

}
